import React, { useState, useEffect } from 'react';
import { callingAPI } from '../config';
import Header from '../layout/header';
import Footer from '../layout/footer';
import Leftmenu from '../Patients/leftmenu';
import Profiledetail from '../Patients/profiledetail';
import Patientright from '../Patients/patientright';
import Close from '../images/icons/close.png';
import upload from '../images/icons/upload.png';
import pulseMain from '../images/icons/blankImg.jpg';
import Loader from '../Common/loader';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		width: '100% !important',
	},
};
const images = [
	'https://media.istockphoto.com/photos/freedom-chains-that-transform-into-birds-charge-concept-picture-id1322104312?b=1&k=20&m=1322104312&s=170667a&w=0&h=VQyPkFkMKmo0e4ixjhiOLjiRs_ZiyKR_4SAsagQQdkk=',
	'https://media.istockphoto.com/photos/freedom-chains-that-transform-into-birds-charge-concept-picture-id1322104312?b=1&k=20&m=1322104312&s=170667a&w=0&h=VQyPkFkMKmo0e4ixjhiOLjiRs_ZiyKR_4SAsagQQdkk=',
	'data:image/png;base64,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',
];
const captions = [
	"1/3", "2/3", "3/3"]
function PatientFiles() {
	const ArrowLeft = (props) => (
		<button
			{...props}
			className={'prev triangle-left '} title='Previous (Left arrow key)' />
	);
	const ArrowRight = (props) => (
		<button
			{...props}
			className={'next triangle-right'} title='Next (Right arrow key)' />
	);
	var settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: <ArrowLeft />,
		nextArrow: <ArrowRight />,
	};
	const [allImagesDatas, setAllImagesData] = useState([]);
	const [allImagesDatas1, setAllImagesData1] = useState([]);
	const [patientGallery, setPatientGallery] = useState([]);
	const [langData, setLangData] = useState([]);
	const [folderArray, setFolderArray] = useState([]);
	const [getNullData, setNullData] = useState([]);
	const [getFolderImages, setFolderImages] = useState([]);
	const [load, setLoad] = useState(false);
	const [getFolderName, setFolderName] = useState('');
	const [getImagePath, setImagePath] = useState(process.env
		.REACT_APP_S3_BUCKET_URL +
		process.env
			.REACT_APP_S3_ENVIRONMEWNT_TYPE +
		process.env
			.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
		'/')
	const [getOpenImg, setOpenImg] = useState();
	const [getOrthodonticView, setOrthodonticView] = useState([]);
	const [getBeforeAndafter, setBeforeAndafter] = useState([]);
	const [getpatientOrtho1, setpatientOrtho1] = useState(pulseMain);
	const [getpatientOrtho2, setpatientOrtho2] = useState(pulseMain);
	const [getpatientOrtho3, setpatientOrtho3] = useState(pulseMain);
	const [getpatientOrtho4, setpatientOrtho4] = useState(pulseMain);
	const [getpatientOrthoSize, setpatientOrthoSize] = useState("");
	const [getpatientOrtho5, setpatientOrtho5] = useState(pulseMain);
	const [getpatientOrtho6, setpatientOrtho6] = useState(pulseMain);
	const [getpatientOrtho7, setpatientOrtho7] = useState(pulseMain);
	const [getpatientOrtho8, setpatientOrtho8] = useState(pulseMain);
	const [getpatientOrtho9, setpatientOrtho9] = useState(pulseMain);
	const [getpatientOrtho10, setpatientOrtho10] = useState(pulseMain);
	const [getAfter, setAfter] = useState(pulseMain);
	const [getBefor, setBefor] = useState(pulseMain);
	const [resultArray, setArray] = useState([])
	const [photoIndex, setphotoIndex] = useState(0);
	const [isOpen, setisOpen] = useState(false);
	const [isOpen1, setisOpen1] = useState(false);
	var getS3folder =
		process.env.REACT_APP_S3_URI +
		process.env.REACT_APP_S3_ENVIRONMEWNT_TYPE +
		process.env.REACT_APP_S3_HOSPITAL_LOGO_PATH;
	useEffect(() => {
		patientListing();
	}, []);
	const handleOnError = (e) => {
		// alert("kkkkkkkkkkkkk")
		e.target.src = pulseMain
	}
	const patientListing = () => {
		const apiJson = {
			memberId: window.sessionStorage.getItem('memberId'),
			hospitalId: localStorage.getItem('hospitalId'),
		};
		callingAPI('clinicalBackground/patientDentalFileList', apiJson).then((data) => {
			if (data.data.success === '1') {
				setPatientGallery(data.data.result.patientGallery);
				let result = [];
				result = data.data.result.patientOrthoSize.sort((a, b) => {
					return a.Description - b.Description
				})
				setOrthodonticView(result);
				setArray(data.data.result)
				setBeforeAndafter(data.data.result.memberBeforeAndAfter);
				setNullData(data.data.result.NullData)
				var allImages = []
				data.data.result.patientGallery.map((obj) => {
					var a = process.env.REACT_APP_S3_BUCKET_URL +
						process.env
							.REACT_APP_S3_ENVIRONMEWNT_TYPE +
						process.env
							.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
						'/' + obj.ImageName
					allImages.push(a)
				})
				setAllImagesData(allImages)
				if (data.data.result.beforeArray.length > 0) {
					setBefor(data.data.result.beforeArray[0].ImageName)
				}
				if (data.data.result.memberAfter.length > 0) {
					setAfter(data.data.result.memberAfter[0].ImageName)
				}
				setFolderArray(data.data.result.folderArray);
				if (data.data.result.patientOrtho1.length > 0) {
					setpatientOrtho1(getImagePath + data.data.result.patientOrtho1[0].ImageName);
				}
				else {
					setpatientOrtho1(pulseMain);
				}
				if (data.data.result.patientOrtho2.length > 0) {
					setpatientOrtho2(getImagePath + data.data.result.patientOrtho2[0].ImageName);
				}
				else {
					setpatientOrtho2(pulseMain);
				}
				if (data.data.result.patientOrtho3.length > 0) {
					setpatientOrtho3(getImagePath + data.data.result.patientOrtho3[0].ImageName);
				}
				else {
					setpatientOrtho3(pulseMain);
				}
				if (data.data.result.patientOrtho4.length > 0) {
					setpatientOrtho4(getImagePath + data.data.result.patientOrtho4[0].ImageName);
				}
				else {
					setpatientOrtho4(pulseMain);
				}
				if (data.data.result.patientOrthoSize.length > 0) {
					// setpatientOrthoSize(getImagePath + data.data.result.patientOrthoSize[0].logoImage);
					setpatientOrthoSize(getS3folder + "/" + localStorage.getItem("hospitalId") + ".png")
				}
				else {
					setpatientOrthoSize(pulseMain);
				}
				if (data.data.result.patientOrtho5.length > 0) {
					setpatientOrtho5(getImagePath + data.data.result.patientOrtho5[0].ImageName);
				}
				else {
					setpatientOrtho5(pulseMain);
				}
				if (data.data.result.patientOrtho6.length > 0) {
					setpatientOrtho6(getImagePath + data.data.result.patientOrtho6[0].ImageName);
				}
				else {
					setpatientOrtho6(pulseMain);
				}
				if (data.data.result.patientOrtho7.length > 0) {
					setpatientOrtho7(getImagePath + data.data.result.patientOrtho7[0].ImageName);
				}
				else {
					setpatientOrtho7(pulseMain);
				}
				if (data.data.result.patientOrtho8.length > 0) {
					setpatientOrtho8(getImagePath + data.data.result.patientOrtho8[0].ImageName);
				}
				else {
					setpatientOrtho8(pulseMain);
				}
				if (data.data.result.patientOrtho9.length > 0) {
					setpatientOrtho9(getImagePath + data.data.result.patientOrtho9[0].ImageName);
				}
				else {
					setpatientOrtho9(pulseMain);
				}
				if (data.data.result.patientOrtho10.length > 0) {
					setpatientOrtho10(getImagePath + data.data.result.patientOrtho10[0].ImageName);
				}
				else {
					setpatientOrtho10(pulseMain);
				}
			}
			setLoad(true);
		});
	};
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			document.getElementById('imgId').style.display = 'none';
		}
	});
	const closePopUp1 = () => {
		setOpenImg()
		document.getElementById('imgId').style.display = 'none';
	}
	const closePopUp2 = () => {
		setLangData([])
		document.getElementById('imgId1').style.display = 'none';
	}
	const openImgOrtho = () => {
		document.getElementById('imgId1').style.display = 'block';
	}
	const closePopUp3 = () => {
		document.getElementById('imgId2').style.display = 'none';
	}
	const openImgAfterBefore = () => {
		document.getElementById('imgId2').style.display = 'block';
	}
	const allImagesData = () => {
		window.location.reload();
		document.getElementById('nullImages').style.display = 'block';
		document.getElementById('divOrthodonticView').style.display = 'none';
		document.getElementById('divBeforeAfter').style.display = 'none';
		document.getElementById('oneObject').style.display = 'none';
	};
	const allOrthoData = () => {
		// window.location.reload();
		document.getElementById('nullImages').style.display = 'none';
		document.getElementById('divOrthodonticView').style.display = 'block';
		document.getElementById('divBeforeAfter').style.display = 'none';
		document.getElementById('oneObject').style.display = 'none';
	};
	const beforeAfterData = () => {
		// window.location.reload();
		document.getElementById('nullImages').style.display = 'none';
		document.getElementById('divOrthodonticView').style.display = 'none';
		document.getElementById('divBeforeAfter').style.display = 'block';
		document.getElementById('oneObject').style.display = 'none';
	};
	const imageDelete = (dentId) => {
		var x = false;
		x = window.confirm('Do you want to Delete this?');
		if (x === true) {
			const satusData = {
				memberId: window.sessionStorage.getItem('memberId'),
				fileId: dentId,
			};
			callingAPI('clinicalBackground/deleteDentalFiles', satusData).then((data) => {
				if (data.data.success === '1') {
					alert('Deleted Successfully');
					window.location = '/patients/patientFiles';
					patientListing();
				}
				if (data.data.success === '0') {
					alert(data.data.errorMessage);
				}
				setLoad(true);
			});
		}
	};
	const folderImages = (data) => {
		var langData = [];
		for (var i = 0; i < data.imageName.length; i++) {
			langData.push(getImagePath + data.imageName[i].imageName);


		}
		setFolderImages(data.imageName);
		setFolderName(data.folder_name);
		setAllImagesData(langData)
		document.getElementById('nullImages').style.display = 'none';
		document.getElementById('oneObject').style.display = 'block';
	};
	const allImages = () => {
		window.location.href = '/patients/patientFiles';
	};
	const openImg = (index) => {
		var langData = [];
		for (var i = index; i < getNullData.length; i++) {
			var y = { "ImageName": getNullData[i].ImageName }
			langData.push(y);
		}
		for (var j = 0; j < index; j++) {
			var x = { "ImageName": getNullData[j].ImageName };
			langData.push(x);
		}
		setLangData(langData)
		document.getElementById('imgId').style.display = 'block';
	}
	return (
		<div className="coverWraper" >
			<Header />
			<div className="contentWraper contentWraperScroll ptFiles">
				<Leftmenu />
				<div className="rightSection">
					<Profiledetail />
					<div className="practiceManagementWrap">
						<div className="row practiceManagementRow">
							<div className="col-lg-8 col-md-12 practiceLeftSection">
								{load === false ? <Loader /> : ''}
								<div class="treatmentPlanWrap patientConsultInnerPgeLoadDiv_PTour">
									<div id="divPatientContent" class="sideMenuContent">
										<div class="treatmentPlanCover" id="treatmentPlanListDiv" style={{ border: 'none' }}>
											<div class="treatmentPlanHead">
												<span class="treatmentPlanName">IMAGE GALLERY</span>
												<a href="/patients/patientFilesAdd">
													<span class="treatmentPlanBtn pl_blue_btn">+ Add</span>
												</a>
											</div>
											{/*  */}
											{patientGallery.length > 0 ? (
												<div class="treatmentImageGallery">
													<div class="treatmentImageBtns">
														<span id="spanOrtho" onClick={allOrthoData}>
															Orthodontic View
														</span>
														<span id="spanBefore" onClick={beforeAfterData}>
															Before &amp; After
														</span>
														<span id="spanOthers" onClick={() => {
															allImagesData();
															// allImages();
														}}>
															All Images
														</span>
													</div>
													<div
														class="treatmentGalleryPortion"
														id="divMainGallery"
														style={{ display: 'none' }}
													>
														<div class="gallerySliderView" id="divOrthoOthers" title="Click to Full View">
															<div id="divGalAll" class="galleryTitle">
																All Images
																<div class="col-md-12 p-0">
																	<span className="breadcrumb-ul " onClick={allImages} >
																		All Images
																	</span>
																	<span className="breadcrumb-ul">
																		<a> {getFolderName}</a>
																	</span>
																</div>
															</div>
															{/* </div> */}
														</div>
													</div>
													{/* ==================== LIGHT BOX MODIFIED BEGINS HERE ================ */}
													<div className='gallerySliderView'
														id="nullImages" style={{ display: 'block' }}>
														<div class="sliderFullView sliderFullViewNew">
															<div id="divGalAll" class="galleryTitle">All Images</div>
															{patientGallery.map((itemObj, i) => (
																(itemObj.FolderName == "null" || itemObj.FolderName == null ?
																	<div className='item'>
																		<img src={
																			process.env
																				.REACT_APP_S3_BUCKET_URL +
																			process.env
																				.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																			process.env
																				.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																			'/' +
																			itemObj.ImageName
																		} width="25%" height="100%" onClick={() => (setisOpen(true), setphotoIndex(i))} />
																		<span class="uploadIcon">
																			<img
																				src={Close}
																				title="Click to Delete"
																				onClick={() =>
																					imageDelete(itemObj.DentId)}
																			/>
																		</span>
																	</div> :
																	<></>
																)
															))}
															<span id="folderList123"    >
																{folderArray.map((data) => (
																	<span class="sliderFullView sliderFullViewNew">
																		{/* <div id="divNullData"> */}
																		<div class="item ">
																			<img
																				src={upload}
																				className="uploadImg"
																				onClick={() => folderImages(data)}
																			/>

																			<span> {data.folder_name}</span>
																		</div>
																	</span>
																	// </div>
																))}
															</span>
														</div>
														{isOpen ?
															<Lightbox style={customStyles}
																mainSrc={allImagesDatas[photoIndex]}
																imageCaption={(photoIndex + 1) + '/' + allImagesDatas.length}
																nextSrc={allImagesDatas[(photoIndex + 1) % allImagesDatas.length]}
																prevSrc={allImagesDatas[(photoIndex + allImagesDatas.length - 1) % allImagesDatas.length]}
																onCloseRequest={() => (setisOpen(false))}
																onMovePrevRequest={() =>
																({
																	photoIndex: setphotoIndex((photoIndex + allImagesDatas.length - 1) % allImagesDatas.length)
																})
																}
																onMoveNextRequest={() =>
																({
																	photoIndex: setphotoIndex((photoIndex + 1) % allImagesDatas.length)
																})
																}
															/>
															: ""}
													</div>
													<div id="oneObject" style={{ display: 'none' }}>
														<div class="col-md-12 p-0" id="folderList123" style={{ display: 'inline-block' }}>
															<span className="breadcrumb-ul"
																onClick={allImages} style={{ cursor: 'pointer', display: 'block' }} >
																All Images
															</span>
															<a class="arr arr-prev"></a>
															<span className="breadcrumb-ul">
																<a> {getFolderName}</a>
															</span>
														</div>
														<div class="sliderFullView sliderFullViewNew">
															<div id="divNullData">
																{getFolderImages.map((image, i) => (
																	<div class="item itemFolder">
																		<div className="itemFolderIcon1 folderViewMoreImg" style={{ width: '100%' }}>
																			<img
																				src={
																					process.env
																						.REACT_APP_S3_BUCKET_URL +
																					process.env
																						.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																					process.env
																						.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																					'/' +
																					image.imageName
																				} style={{ width: '100%' }}
																				onClick={() => (setisOpen(true), setphotoIndex(i))}
																			/>
																			<span class="uploadIcon">
																				<img
																					src={Close}
																					title="Click to Delete"
																					onClick={() =>
																						imageDelete(image.dentId)}
																				/>
																			</span>
																		</div>
																	</div>
																))}
															</div>
														</div>
													</div>
													{/* ==================== LIGHT BOX MODIFIED ENDS HERE ================ */}
													{/*  ======================= Orthodontic View Begins Here =======================================  */}
													<div
														class="treatmentGalleryPortion"
														id="divOrthodonticView"
														style={{ display: 'none' }}
													>
														<div class="gallerySliderView" id="divOrthoOthers">
															<div id="divGalAll" class="galleryTitle" >
																Orthodontic View
															</div>
															<div class="galleryOrtho" onClick={() =>
																openImgOrtho()} >
																<div class="orthoView" title="Click to Full View">
																	<span>
																		<img
																			src={getpatientOrtho1
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span>
																		<img
																			src={getpatientOrtho2
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span >
																		<img
																			src={getpatientOrtho3
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span>
																		<img
																			src={getpatientOrtho4
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span>
																		<img
																			src={getpatientOrthoSize
																			}
																			class="uploadImgDental"
																			onError={(e) => handleOnError(e)}
																		/>
																	</span>
																	<span >
																		<img
																			src={getpatientOrtho5
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span >
																		<img
																			src={getpatientOrtho6
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span >
																		<img
																			src={getpatientOrtho7
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																	<span >
																		<img
																			src={getpatientOrtho8
																			}
																			class="uploadImgDental"
																		/>
																	</span>
																</div>
																<div class="xRayView">
																	<span>
																		<img src={getpatientOrtho9} class="uploadImgDental" />
																	</span>
																	<span>
																		<img src={getpatientOrtho10} class="uploadImgDental" />
																	</span>
																</div>
															</div>
														</div>
													</div>
													{/*  ===================== Orthodontic View Ends Here =========================================== */}
													{/*  ===================== Before & After begins Here =========================================== */}
													<div
														class="treatmentGalleryPortion"
														id="divBeforeAfter"
														style={{ display: 'none' }}>
														<div class="gallerySliderView" id="divOrthoOthers">
															<div id="divGalAll" class="galleryTitle">
																Before & After
															</div>
															<div style={{ display: 'block' }}>
																<div class="sliderFullView sliderFullViewNew" title="Click to Full View">
																	<div class="beforeAfterView" onClick={() =>
																		openImgAfterBefore()}  >
																		<div class="beforeView">
																			<span class="galleryViewName">Before</span>
																			<img src={
																				getBefor === pulseMain ? pulseMain : process.env
																					.REACT_APP_S3_BUCKET_URL +
																					process.env
																						.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																					process.env
																						.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																					'/' +
																					getBefor} />
																		</div>
																		<div class="beforeView">
																			<span class="galleryViewName">After</span>
																			<img src={
																				getAfter === pulseMain ? pulseMain :
																					process.env
																						.REACT_APP_S3_BUCKET_URL +
																					process.env
																						.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																					process.env
																						.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																					'/' +
																					getAfter} />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													{/*  ===================== Before & After Ends Here =========================================== */}
												</div>
											) :
												<div className="ImageGalleryWrap">
													<h3>No Image Gallery Found</h3>
												</div>
											}
											{/* No image Gallery found ends */}
										</div>
									</div>
								</div>
								{/*  */}
							</div>
							<div className="col-md-4 practiceRightSection">
								<Patientright />
							</div>
						</div>
					</div>
					{/* --------------------imgPopUp--------------------------- */}
					<div className="ploverlayy patientFilesDentalPopupGalleryploverlayy" style={{ display: 'none' }} id="imgId">
						<div className="plpopup plpopupList patientFilesDentalPopupGallery  ">
							<div class="addDataHead appointmentPopupClose" style={{ borderBottom: 'none' }}>
								<a href="#" id="btnCancel" class="close" onClick={closePopUp1}>
									<span class="popUpClose" title='Close (Esc)'>&times;</span>
								</a>
							</div>
							<div className="popBack" id="popup1">
								<div className="popOverlay" />
								<div className="row">
									<div className="customizationPop">
										<div className="customizationPopContentSec">
											<input type="hidden" id="txtHiddenCategoryId" />
											<div className="contentWraper contentWraperScroll whiteBg"
												style={{ minHeight: 'auto', background: "transparent" }}>
												<div className="innerContent plAppContent" style={{ padding: "0px" }}>
													<div className="addpatientContent">
														<div className="row">
															<div className="col-md-12">
																<div className="row appointmentForm">
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* --------------------------------------- */}
					{/* --------------------imgPopUp--------------------------- */}
					<div className="ploverlayy  patientFilesDentalPopupOVERLAY" style={{ display: 'none' }} id="imgId1">
						<div className="plpopup plpopupList  patientFilesDentalPopup">
							<div class="addDataHead appointmentPopupClose" style={{ borderBottom: 'none' }}>
								<a href="#" id="btnCancel" class="close" onClick={closePopUp2}>
									<span class="popUpClose" title='Close (Esc)'>&times;</span>
								</a>
							</div>
							<div className="popBack" id="popup1">
								<div className="popOverlay" />
								<div className="row">
									<div className="customizationPop">
										<div className="customizationPopContentSec">
											<input type="hidden" id="txtHiddenCategoryId" />
											<div
												className="contentWraper contentWraperScroll whiteBg"
												style={{ minHeight: 'auto' }}
											>
												<div className="innerContent plAppContent" style={{ padding: "0px" }}>
													<div className="addpatientContent">
														<div className="row">
															<div className="col-md-12">
																<div class="galleryOrtho" style={{ border: "none", margin: "0px" }}>
																	<div class="orthoView">
																		<span>
																			<img
																				src={getpatientOrtho1
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span>
																			<img
																				src={getpatientOrtho2
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrtho3
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span>
																			<img
																				src={getpatientOrtho4
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrthoSize
																				}
																				class="uploadImgDental"
																				onError={(e) => handleOnError(e)}
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrtho5
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrtho6
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrtho7
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																		<span >
																			<img
																				src={getpatientOrtho8
																				}
																				class="uploadImgDental"
																			/>
																		</span>
																	</div>
																	<div class="xRayView">
																		<span>
																			<img src={getpatientOrtho9} class="uploadImgDental" />
																		</span>
																		<span>
																			<img src={getpatientOrtho10} class="uploadImgDental" />
																		</span>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* --------------------------------------- */}
					{/* --------------------imgPopUp--------------------------- */}
					<div className="ploverlayy patientFilesDentalPopupOVERLAY" style={{ display: 'none' }} id="imgId2">
						<div className="plpopup plpopupList patientFilesDentalPopup  ">
							<div class="addDataHead appointmentPopupClose" style={{ borderBottom: 'none' }}>
								<a href="#" id="btnCancel" class="close" onClick={closePopUp3}>
									<span class="popUpClose" title='Close (Esc)'>&times;</span>
								</a>
							</div>
							<div className="popBack" id="popup1">
								<div className="popOverlay" />
								<div className="row">
									<div className="customizationPop">
										<div className="customizationPopContentSec">
											<input type="hidden" id="txtHiddenCategoryId" />
											<div
												className="contentWraper contentWraperScroll whiteBg"
												style={{ minHeight: 'auto' }}
											>
												<div className="innerContent plAppContent" style={{ padding: "0px" }}>
													<div className="addpatientContent beforeAfterImags">
														<div className="row">
															<div className="col-md-12">
																<div class="galleryOrtho" >
																	<div class="sliderFullView sliderFullViewNew" title="Click to Full View">
																		<div class="beforeAfterView" onClick={() =>
																			openImgAfterBefore()}  >
																			<div class="beforeView">
																				<span class="galleryViewName">Before</span>
																				<img src={
																					getBefor === pulseMain ? pulseMain : process.env
																						.REACT_APP_S3_BUCKET_URL +
																						process.env
																							.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																						process.env
																							.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																						'/' +
																						getBefor} />
																			</div>
																			<div class="beforeView">
																				<span class="galleryViewName">After</span>
																				<img src={
																					getAfter === pulseMain ? pulseMain :
																						process.env
																							.REACT_APP_S3_BUCKET_URL +
																						process.env
																							.REACT_APP_S3_ENVIRONMEWNT_TYPE +
																						process.env
																							.REACT_APP_PATIENT_DENTALFILES_S3_IMAGE_PATH +
																						'/' +
																						getAfter} />
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/*---------------------------------------*/}
				</div>
			</div>
			<Footer />
		</div>
	);
}
export default PatientFiles;
